<template>
  <el-dialog
    :visible="dialogVisible"
    @close="close_dialog"
    custom-class="orange-dialog"
    center
    width="375px"
  >
    <h6 class="title1">
      {{ title1 }}
    </h6>
    <p class="title2">
      {{ title2 }}
    </p>
    <span slot="footer" class="dialog-footer">
      <el-button round @click="cancelFun">取 消</el-button>
      <el-button
        style="background-color: #ff6d42; color: #fff; border: none"
        @click="sureFun"
        round
      >
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogBox',
  props: {
    title1: {
      type: String,
      default: '',
    },
    title2: {
      type: String,
      default: '',
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      centerDialogVisible: false,
    };
  },
  methods: {
    cancelFun() {
      this.$emit('dialogEmit', false);
    },
    sureFun() {
      this.$emit('dialogEmit', true);
    },
    close_dialog() {
      this.$emit('dialogEmit', false);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .orange-dialog {
  margin-top: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .el-dialog__header {
  }

  .el-dialog__body {
    text-align: center;
    .title1 {
      font-size: 16px;
      color: #606266;
      line-height: 45px;
    }
    .title2 {
      font-size: 14px;
      color: #909399;
    }
  }

  .el-dialog__footer {
  }
  .el-button.is-round:hover {
    border: 1px solid #dcdfe6;
  }
}
</style>
